module.exports = __webpack_public_path__ + "img/logo_paxos.be459db2.png";